import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_LZaocWpNp",
  client_id: "1l73824c5dvtk4rspp4jnl5s0f",
  redirect_uri: "https://big-birdie-tracker.com/",
  response_type: "code",
  scope: "email openid profile",
  post_logout_redirect_uri: "https://big-birdie-tracker.com/",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);